<template>
    <div>
        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full">
                <div class="flex flex-wrap mb-4 px-4">
                    <multi-select-input v-model="filters.SalesPromoter.name" :multiple="true"
                        :options="salesPromoterSearch" class="lg:pr-6 w-full lg:w-1/4" label="Nome" />

                    <multi-select-input v-model="filters.SalesPromoter.user_name" :multiple="true"
                        :options="loginSearch" class="lg:pr-6 w-full lg:w-1/4" label="Login" />

                    <multi-select-input v-model="filters.SalesPromoter.email" :multiple="true" :options="emailSearch"
                        class="lg:pr-6 w-full lg:w-1/4" label="E-mail" />

                    <text-input class="w-full lg:w-1/4" label="Pix" v-model="filters.SalesPromoter.pix" />
                </div>
                <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
                    <button
                        class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out "
                        @click.submit.prevent="pesquisar">
                        <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                        Pesquisar
                    </button>

                    <button type="button"
                        class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100"
                        @click.submit.prevent="clearSearch">
                        <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                        Limpar
                    </button>
                </div>
            </form>
        </div>

        <Head title="Promotores" />
        <div class="shadow_box rounded-lg p-6 mt-4">
            <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Promotores</h1>
            <data-table v-if="loadTable" v-model:columns="columns" route="sales_promoter/list" :query="getQuery"
                no-data-label="Nenhum promotor encontrado" no-result-label="Nenhum promotor encontrado"
                class="data-table">
                <template #table.cell.content.email="{ value }">
                    <span class="default-long-text-td">{{ value }}</span>
                </template>
                <template #table.cell.content.login="{ value }">
                    <span class="default-long-text-td">{{ value }}</span>
                </template>
                <template #table.cell.content.pix="{ value }">
                    <span class="default-long-text-td">{{ value }}</span>
                </template>
                <template #table.cell.content.detail="{ value, row }">
                    <div class="place-self-center grid-cols-2 gap-4">
                        <span class="flex items-center justify-center text-sm">
                            <Link :href="'/sales_promoter_link/' + row.id"
                                class="rounded p-2 bg-purple-100 text-white ver-vinculos-link">
                            <span class="ver-vinculos">Ver Vínculos</span>
                            <font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                            </Link>
                        </span>
                    </div>
                </template>
                <template #table.cell.content.promoter_status="{ value, row }">
                    <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo"
                        @click="changeStatus(row)" />
                </template>
                <template #grid.content.body.promoter_status="{ value, row }">
                    <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo"
                        @click="changeStatus(row)" />
                </template>
                <template #table.cell.content.actions="{ value, row }">
                    <div class="inline-grid grid-cols-2 gap-4 ">
                        <span @click="openModalEdit(row)"
                            class="bg-purple-200 text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex action-buttons edit-button">
                            <font-awesome-icon icon="fa-pencil" class="text-white pr-2" /><span
                                class="btn-label">Editar</span>
                        </span>
                        <span @click="openModalConfirmDelete(row)"
                            class="bg-red_delete text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex action-buttons delete-button">
                            <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" /><span
                                class="btn-label">Excluir</span>
                        </span>
                    </div>
                </template>
                <template #grid.content.body.actions="{ value, row }">
                    <div class="inline-grid grid-cols-2 gap-4 ">
                        <span @click="openModalEdit(row)"
                            class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm py-2 px-4">
                            <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
                        </span>
                        <span @click="openModalConfirmDelete(row)"
                            class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm py-2 px-4">
                            <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir
                        </span><font-awesome-icon icon="fa-solid fa-table" class="text-white text-lg mr-0 lg:mr-2" />
                    </div>
                </template>

                <template #after.reload-button>
                    <div class="flex flex-col sm:flex-row w-full gap-3">
                        <button
                            class="flex justify-center items-end font-roboto font-medium btn-primary btn-purple uppercase w-full"
                            @click.prevent="exportData({})">
                            <font-awesome-icon icon="fa-solid fa-table" class="text-white text-lg mr-0 lg:mr-2" /><span
                                class="">
                                Exportar Dados</span>
                        </button>

                        <button
                            class="flex justify-center items-end font-roboto font-medium btn-purple uppercase w-full"
                            @click.prevent="openModalEdit({})">
                            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="">
                                Adicionar Promotor</span>
                        </button>
                    </div>
                </template>
            </data-table>
        </div>
        <modal-delete ref="modalDelete" @confirm="reloadTable" @close="$event => transferLinks = false">
            <template #footer="data">
                <template v-if="data.item.links_count">
                    <div class="flex items-center gap-4 my-4">
                        <switch-input v-model="transferLinks"
                            labelChecked="Deseja transferir os vinculos para outro promotor?"
                            labelUnchecked="Deseja transferir os vinculos para outro promotor?" />
                    </div>

                    <select-input v-if="transferLinks" @input="handleSelectPromoter"
                        class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Promotores">
                        <option value="">Promotor</option>
                        <option v-for="promotor in filterIds(data.item.id)" :key="promotor.id" :value="promotor.id">
                            {{ promotor.name }}
                        </option>
                    </select-input>
                </template>
            </template>
        </modal-delete>
        <modal-edit :modal-scrollable="true" ref="modalEdit" title="Promotores" url="sales_promoter"
            @submitForm="reloadTable" :item="{ address: {}, errors: { user: {}, address: {} } }">
            <template #form="{ item }">
                <div class="lg:pr-6 w-full lg:w-3/4">
                    <label>Dados do usuário</label>
                </div>
                <text-input v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full lg:w-1/2 mt-6"
                    label="Nome" required="true" />
                <text-input v-model="item.email" :error="item.errors.email" class="lg:pr-6 w-full lg:w-1/2 mt-6"
                    label="E-mail" required="true" />
                <text-input v-model="item.user_name" :error="item.errors.user_name" class="lg:pr-6 w-full lg:w-1/2 mt-6"
                    label="Login" required="true" />
                <password-input v-model="item.password" :error="item.errors.password"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Senha" :required="!item.id" />
                <div class="lg:pr-6 w-full lg:w-3/4 mt-6">
                    <label>Dados pessoais</label>
                </div>
                <mask-input v-model="item.rg" mask="##.###.###-#" :error="item.errors.rg"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="RG" />
                <mask-input v-model="item.cpf" mask="###.###.###-##" :error="item.errors.cpf"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="CPF" />
                <text-input v-model="item.mei" :error="item.errors.mei" class="lg:pr-6 w-full lg:w-1/2 mt-6"
                    label="MEI" />
                <mask-input v-model="item.cnpj" mask="##.###.###/####-##" :error="item.errors.cnpj"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="CNPJ" />
                <mask-input :mask="['(##) #####-####']" :clear-incomplete="true" v-model="item.phone"
                    :error="item.errors.phone" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Celular" />
                <cep-input @updateAddress="onUpdateAddress" v-model="item.address.postcode"
                    :error="item.errors[`address.postcode`]" class="lg:pr-6 w-full lg:w-2/6 mt-6" label="CEP" />
                <text-input v-model="item.address.street" :error="item.errors[`address.street`]"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Rua" />
                <text-input v-model="item.address.number" :error="item.errors[`address.number`]"
                    class="lg:pr-6 w-full lg:w-1/4 mt-6" label="Número" />
                <text-input v-model="item.address.complement" :error="item.errors[`address.complement`]"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Complemento" />
                <text-input v-model="item.address.neighborhood" :error="item.errors[`address.neighborhood`]"
                    class="lg:pr-6 w-full lg:w-1/4 mt-6" label="Bairro" />
                <select-input v-model="item.address.state" :error="item.errors[`address.state`]"
                    class="lg:pr-6 w-full lg:w-1/4 mt-6" label="Estado">
                    <option :value="null" />
                    <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}
                    </option>
                </select-input>
                <text-input v-model="item.address.city" :error="item.errors[`address.city`]"
                    class="lg:pr-6 w-full lg:w-1/3 mt-6" label="Cidade" />
                <div class="lg:pr-6 w-full lg:w-3/4 mt-6">
                    <label>Dados bancários</label>
                </div>
                <text-input v-model="item.bank" :error="item.errors.bank" class="lg:pr-6 w-full lg:w-1/2 mt-6"
                    label="Banco" />
                <text-input v-model="item.bank_agency" :error="item.errors.bank_agency"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Agência" />
                <text-input v-model="item.bank_account" :error="item.errors.bank_account"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Conta bancária" />
                <text-input v-model="item.pix" :error="item.errors.pix" class="lg:pr-6 w-full lg:w-1/2 mt-6"
                    label="Pix" />
            </template>
        </modal-edit>
    </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import MaskInput from '@/Shared/MaskInput'
import SwitchInput from '@/Shared/SwitchInput'
import CepInput from '@/Shared/CepInput'
import SelectInput from '@/Shared/SelectInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import PasswordInput from '@/Shared/PasswordInput'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
    components: {
        Head,
        LoadingButton,
        ModalDelete,
        ModalEdit,
        TextInput,
        DataTable,
        MaskInput,
        SwitchInput,
        CepInput,
        SelectInput,
        MultiSelectInput,
        PasswordInput,
        Link,
    },
    props: {
        states_options: Object,
        promoter_list: Array,
        salesPromoterSearch: Array,
        loginSearch: Array,
        emailSearch: Array,
    },
    layout: Layout,

    data() {
        return {
            loadTable: true,
            transferLinks: false,
            columns: [
                {
                    uniqid: 'name',
                    label: 'Nome',
                    field: 'name',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => `${row.name}`,
                },
                {
                    uniqid: 'login',
                    label: 'Login',
                    field: 'user_name',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm col-login',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => `${row.user_name}`,
                },
                {
                    uniqid: 'email',
                    label: 'E-mail',
                    field: 'email',
                    visible: true,
                    classes: 'px-4 py-3 border-b text-sm col-email whitespace-nowrap overflow-hidden text-ellipsis',
                    headerClass: 'p-4',
                    format: (val, row) => `${row.email}`,
                },
                {
                    uniqid: 'pix',
                    label: 'Pix',
                    field: 'pix',
                    visible: true,
                    sortable: true,
                    classes: 'px-4 py-3 border-b text-sm col-pix whitespace-nowrap overflow-hidden text-ellipsis',
                    headerClass: 'p-4',
                    format: (val, row) => val ? val : ''
                },
                {
                    uniqid: 'promoter_status',
                    label: 'Situação',
                    field: 'status',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'detail',
                    label: 'VÍNCULOS DO PROMOTOR',
                    field: 'id',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'actions',
                    label: 'Ações',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
            ]
        }
    },

    computed: {
        getQuery() {
            return Object.entries(this.getFilters()).map(([key, val]) => `search2[${key}]=${val}`).join('&')
        },
    },

    methods: {
        filterIds: function (id) {
            return this.$props.promoter_list?.filter(promoter => promoter.id != id)
        },
        handleSelectPromoter: function ($event) {
            this.$refs.modalDelete.setPayload({ id: $event.target.value })
        },
        changeStatus(item) {
            item.status = !item.status;
            this.$inertia.post("/sales_promoter/update-status", item);
        },
        clearSearch() {
            this.clearFilters()
            this.reloadTable();
        },
        pesquisar() {
            this.reloadTable();
        },
        exportData() {
            window.open('/sales_promoter/export', '_blank', 'noreferrer');
        },
        openModalConfirmDelete(item) {
            this.$refs.modalDelete.openModalDelete(item, `/sales_promoter/${item.id}`, `Deseja realmente excluir o promotor ${item.name}?`);
        },
        openModalEdit(i) {
            let item = {
                id: i.id,
                name: i.name,
                user_name: i.user_name,
                email: i.email,
                // senha só é necessária no cadastro; em edição, manter vazia para alteração opcional
                password: '',
                rg: i.rg ?? '',
                cpf: i.cpf,
                mei: i.mei,
                cnpj: i.cnpj,
                bank: i.bank,
                bank_agency: i.bank_agency,
                bank_account: i.bank_account,
                pix: i.pix,
                phone: i.phone,
                address: {},
            }
            if (i.address) {
                item.address = {
                    id: i.address.id,
                    street: i.address.street,
                    number: i.address.number,
                    complement: i.address.complement,
                    neighborhood: i.address.neighborhood,
                    state: i.address.state,
                    city: i.address.city,
                    postcode: i.address.postcode,
                }
            }

            this.$refs.modalEdit.openModalEdit(item);
        },
        reloadTable() {
            this.loadTable = false;
            setTimeout(() => this.loadTable = true, 10);
        },
        onUpdateAddress(json) {
            this.$refs.modalEdit.item.address.city = json.localidade;
            this.$refs.modalEdit.item.address.state = json.uf;
            this.$refs.modalEdit.item.address.street = json.logradouro;
            this.$refs.modalEdit.item.address.neighborhood = json.bairro;
        },
    },

    setup() {
        const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

        setFiltersComponent('SalesPromoter')

        const clearFilters = () => clearFiltersComponent('SalesPromoter')
        const getFilters = () => getFiltersComponent('SalesPromoter')

        return {
            getFilters,
            clearFilters,
            filters: filtersStore.filters
        }
    }
}
</script>

<style scoped>
@media screen and (min-width: 1280px) and (max-width: 1366px) {
    .default-long-text-td {
        overflow-wrap: break-word !important;
    }

    .edit-button,
    .delete-button {
        overflow: hidden !important;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 50px;
    }

    .fa-pencil,
    .fa-trash-can {
        padding: 0;
    }

    .btn-label {
        display: none !important;
    }

    .ver-vinculos-link {
        display: flex;
        align-items: center;
        line-height: 1;
    }

    .ver-vinculos-link:is(:hover, :focus),
    .action-buttons:is(:hover, :focus) {
        filter: brightness(1.1);
        transition: filter .2s ease-in-out;
    }

    .ver-vinculos {
        font-size: .75rem !important;
    }
}
</style>
